<script>
	import { getDateFormatter } from "../../../../../SharedSvelte/Common.svelte";
	import { Card, CardBody, CardHeader } from "@sveltestrap/sveltestrap";

	let {
        fullName = "",
        memberId = "",
        ssn = "",
        dateOfBirth = null
    } = $props();   

	const dateFormatter = getDateFormatter();
    let formattedDob = dateFormatter.format(dateOfBirth ? new Date(dateOfBirth) : null);   
</script>

<Card class="bg-light mb-3">
    <CardBody>
	    <div class="row">
            <div class="col-md-4 col-sm-4 col-xs-4">Name:</div>
            <div class="col-md-6 col-sm-6 col-xs-12 ms-2"><strong>{fullName}</strong></div>
        </div>
        <div class="row">
            <div class="col-md-4 col-sm-4 col-xs-12">Member ID:</div>
            <div class="col-md-6 col-sm-6 col-xs-12 ms-2"><strong>{memberId}</strong></div>
        </div>
        <div class="row">
            <div class="col-md-4 col-sm-4 col-xs-12">SSN:</div>
            <div class="col-md-6 col-sm-6 col-xs-12 ms-2"><strong>{ssn}</strong></div>
        </div>
        <div class="row">
            <div class="col-md-4 col-sm-4 col-xs-12">Date of Birth:</div>
            <div class="col-md-6 col-sm-6 col-xs-12 ms-2"><strong>{formattedDob}</strong></div>
        </div>            
    </CardBody>
</Card>      